export default {
  // 新增
  insertMapString: '/backstageApi/account/backstage/usercenter/config/saveMapString',
  // 分页
  queryMapStringListPage: '/backstageApi/account/backstage/usercenter/config/queryMapStringPage',
  // 更新
  updateMapString: '/backstageApi/account/backstage/usercenter/config/editMapString',
  // key为device-auth-config，写死的
  selectOneMapString: '/backstageApi/account/backstage/usercenter/config/selectOne',
  // 生成key
  createKey: '/backstageApi/account/backstage/usercenter/config/createKey'

}



// WEBPACK FOOTER //
// ./src/api/mapString.js